<template>
  <div class="main">
      <pdf :src="pdfUrl"
            v-for="i in numPages"
            :key="i"
            :page="i"
            style="width:100%"></pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { fileInfo,fileDownloadByInnerUrl } from "@/api/templateManagement";

export default {
  name: '',
  mixins: [],
  components: {pdf},
  props: {},
  data() {
    return {
        pdfUrl:'',
        numPages: undefined,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
      const url = this.$route.query.file
        fileInfo({ fileShowUrl: url }).then(res => {
            if (res.code == 200) {
                fileDownloadByInnerUrl(url).then(resp => {
                    this.pdfUrl = pdf.createLoadingTask(URL.createObjectURL(resp))

                    this.pdfUrl.then(pdf => {
                        this.numPages = pdf.numPages;
                    });

                }).catch(()=>{

                });
            }
        });
  },
  destroyed() {},
  methods: {}
};
</script>
<style  scoped>
.main{}
</style>